module.exports = __webpack_public_path__ + "assets/img/09f3-nl.svg";